<template>
  <div class="createAn7-html">

    <div class="createAn7-box intro-x">
      <div class="createAn7-item">
        <div class="appName">应用主名称</div>
        <div class="elInput">
          <el-input v-model="hostName" placeholder="输入应用主名称"></el-input>
        </div>
      </div>
    </div>

    <div v-for="(item, index) in createAn7" :key="index" class="createAn7-box intro-x">
      <div class="createAn7-item">
        <div class="appName">{{ item.title| fSystem}}端</div>
        <div class="elInput">
          <el-input v-model="item.name" placeholder="输入应用名称"></el-input>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props:['appData'],
  data() {
    return {
      imageUrl: null,
      createAn7: [],
      hostName: '',
    };
  },

 mounted: function(){
   this.init()
 },
 methods:{
    init: function(){
      let arr = this.appData.data.platform.split(',')
      for(let i in arr) {
          this.createAn7.push({
            title: arr[i],
            name:""
          })
      }
    },
 }
};
</script>

<style lang="scss" scoped>
.createAn7-html {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}

.createAn7-box {
  display: inline-block;
  margin-right: 20px;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
  .createAn7-item {
    width: 194px;

    background: #ffffff;
    border: 1px solid #eef2f7;
    border-radius: 22px;
    margin-bottom: 20px;
    padding: 10px;
  }
  .createAn7-name {
    font-size: 14px;
    color: #333333;
  }

  .elInput {
    width: 100%;
  }
}


.logoClass {
  text-align: left;
  padding-left: 5px;
}
.appName {
  text-align: left;
  margin-bottom: 7px;
  padding-left: 5px;
}

.avatar-uploader-box {
  overflow: hidden;
  .avatar-uploader {
    width: 110px;
    height: 110px;
    background: #eef2f7;
    float: left;
    border-radius: 12px;
    text-align: center;
    line-height: 110px;
    font-size: 10px;
    margin: 12px 0 8px;
  }
}

@media screen and (max-width:600px) {

  .createAn7-box {
    width: 100% !important;
    padding: 0 20px !important;
    box-sizing: border-box !important;
    .createAn7-item {
      width: 100% !important;
      margin-bottom: 0 !important;
    }
  }


}




</style>
